import { render } from "./CreateReport.vue?vue&type=template&id=6ce3a35b&scoped=true"
import script from "./CreateReport.vue?vue&type=script&lang=js"
export * from "./CreateReport.vue?vue&type=script&lang=js"

import "./CreateReport.vue?vue&type=style&index=0&id=6ce3a35b&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce3a35b"]])

export default __exports__